import React, { useState } from "react";
import { filterList } from "../../../Lists/products/filterList";
import Category from "../../../components/UI/Category";
import classes from "./filterproducts.module.css";
import Subcategory from "../../../components/Subcategorymenu";
import { useParams } from "react-router-dom";
import filterResidentialProductList from "../../../Lists/products/filterProducts/filterResidentialList";
import filterComercialProductList from "../../../Lists/products/filterProducts/filterComercialList";
import hirotermalBrand from "../../../images/brands/brands_hidrotermal.svg";
import oneBrand from "../../../images/brands/one-01.svg";
import BGPBrand from "../../../images/brands/brands_BGP.svg";

const SurfaceProducts = () => {
  const newArray = [];

  const params = useParams();
  const listCategory = filterList.find(
    (category) => category.path === params.filterId
  );
  const HidrotemalLogoBrand = {
    image: hirotermalBrand,
    alt: "Hidrotermal",
  };
  const OneLogoBrand = {
    image: oneBrand,
    alt: "Hidrotermal",
  };
  const BGPLogoBrand = {
    image: BGPBrand,
    alt: "BGP",
  };

  const findListHandle = (path) => {
    if (path === "comercial") {
      return filterComercialProductList;
    }
    if (path === "residencial") {
      return filterResidentialProductList;
    }
  };

  const originalList = findListHandle(listCategory.path);

  const [displayedList, setdisplayedList] = useState(
    findListHandle(listCategory.path)
  );

  const findBrand = (brand) => {
    if (brand === "Sistemas OneStop") {
      return OneLogoBrand;
    }
    if (brand === "Purificador") {
      return HidrotemalLogoBrand;
    }
    if (brand === "Suavizador") {
      return HidrotemalLogoBrand;
    } else return BGPLogoBrand;
  };
  const findCategoryBrand = (brand) => {
    if (listCategory.title === "Residencial") {
      return BGPLogoBrand;
    } else return "none";
  };

  const [displayedBrand, setdisplayedBrand] = useState(findCategoryBrand);

  const onListChange = (category) => {
    newArray.length = 0;
    originalList.map((element) => sort(element, category));
    setdisplayedList(newArray);
    setdisplayedBrand(findBrand(category));
  };

  const sort = (element, category) => {
    if (element.category === category) {
      newArray.push(element);
    }
  };
  return (
    <div className={classes.showProducts}>
      <section>
        <Subcategory
          onListChange={onListChange}
          categoryList={listCategory.list}
        ></Subcategory>
      </section>
      <section className={classes.Categories}>
        <Category
          brand={displayedBrand}
          title={listCategory.title}
          list={displayedList}
        ></Category>
      </section>
    </div>
  );
};

export default SurfaceProducts;
